import { localeCodes } from '@ringcentral/rwc-utils/src/constants/locales';
import { FALLBACK_LANG } from '@rwc/constants/white-labeling';

const languages = Object.values(localeCodes);

export const getLocale = (lang: string): string =>
    languages.includes(lang) ? lang : FALLBACK_LANG;
